import React from 'react';
import {
  params,
  shape,
  string as stringType,
  bool as boolType,
  useDataModel,
} from '@thd-nucleus/data-sources';
import { string } from 'prop-types';
import { ContributorDetails } from './subcomponents/ContributorDetails';
import { TimeAndDifficulty } from './subcomponents/TimeAndDifficulty';
import styles from './article-info.module.scss';

export const ArticleInfoDetails = ({ articleGUID }) => {
  const { data, loading, error } = useDataModel('article', { variables: { articleGUID } });

  const articleType = data?.article?.articleType || 'ap';
  const articleTypeMappings = {
    ab: 'Buying Guide',
    ai: 'Inspiration Guide',
    ah: 'Project Guide',
    ap: 'Influencer Guide',
  };

  const isInfluencer = articleTypeMappings[articleType] === articleTypeMappings.ap;
  const isProjectGuide = articleTypeMappings[articleType] === articleTypeMappings.ah;
  const difficulty = data?.article?.difficulty || {};
  const duration = data?.article?.duration || {};
  const contributorDetails = data?.article?.contributorDetails || {};
  const img = data?.article?.articleHeader?.thumbnail || '';
  const url = data?.article?.canonicalURL || '';

  if (loading || error || !data) return null;

  /* eslint-disable no-nested-ternary */
  return (
    <>
      {isInfluencer && contributorDetails?.contributorName ? (
        <ContributorDetails contributorDetails={contributorDetails} url={url} img={img} />
      ) : isProjectGuide ? (
        <TimeAndDifficulty difficulty={difficulty} duration={duration} />
      ) : null}
      {isProjectGuide && <div className={styles['article-info__details-divider']} />}
    </>
  );
};

ArticleInfoDetails.propTypes = {
  articleGUID: string.isRequired,
};

ArticleInfoDetails.displayName = 'ArticleInfoDetails';

ArticleInfoDetails.dataModel = {
  article: params({ articleGUID: stringType().isRequired() }).shape({
    articleType: stringType(),
    articleTypeDescription: stringType(),
    canonicalURL: stringType(),
    contributorDetails: shape({
      contributorGUID: stringType(),
      contributorImage: stringType(),
      contributorName: stringType(),
    }),
    articleHeader: shape({
      thumbnail: stringType(),
    }),
    difficulty: shape({
      display: stringType(),
      selected: boolType(),
      value: stringType(),
    }),
    duration: shape({
      display: stringType(),
      selected: boolType(),
      value: stringType(),
    }),
  }),
};
